import { ViewerSearchQuery } from "./dto/ViewerSearchQuery";
import { ViewerSearchQueryResult } from "./dto/ViewerSearchQueryResult";
import { UpdateViewerLocationCollapseStateCommand } from "./dto/UpdateViewerLocationCollapseStateCommand";
import { DismissViewerNewsItemCommand } from "./dto/DismissViewerNewsItemCommand";

export async function loadMessagesResponseItem(baseUrl: string, query: ViewerSearchQuery) : Promise<ViewerSearchQueryResult> {
    let realUrl = `${baseUrl.startsWith('http') ? '' : window.location.origin}${baseUrl}`;
    let url = new URL("api/viewer/search", realUrl);
    let body = JSON.stringify(query, null, 2);
    let headers = { 
        "Accept": "application/json",
        "Content-Type": "application/json" 
    }
    let response = await fetch(url, { 
        method: "POST", 
        headers, 
        body
    });
    return await response.json() as ViewerSearchQueryResult;    
}

export async function updateViewerLocationCollapseState(baseUrl: string, cmd: UpdateViewerLocationCollapseStateCommand) : Promise<void> {
    let realUrl = `${baseUrl.startsWith('http') ? '' : window.location.origin}${baseUrl}`;
    let url = new URL("api/viewer/updateViewerLocationCollapseState", realUrl);
    let body = JSON.stringify(cmd, null, 2);
    let headers = { 
        "Accept": "application/json",
        "Content-Type": "application/json" 
    }
    await fetch(url, { 
        method: "POST", 
        headers, 
        body
    });    
}

export async function dismissViewerNewsItem(baseUrl: string, cmd: DismissViewerNewsItemCommand) : Promise<void> {
    let realUrl = `${baseUrl.startsWith('http') ? '' : window.location.origin}${baseUrl}`;
    let url = new URL("api/viewer/dismissViewerNewsItem", realUrl);
    let body = JSON.stringify(cmd, null, 2);
    let headers = { 
        "Accept": "application/json",    
        "Content-Type": "application/json" 
    }
    await fetch(url, { 
        method: "POST", 
        headers, 
        body
    });    
}